var MDB = window.MDB || {};;
MDB.DPO = MDB.DPO || {};
MDB.DPO.Export = MDB.DPO.Export || {};

(function(){
    var _config = {};
    
    $.extend(MDB.DPO.Export, {
        initializeExportButtons: function(config){
            _config = config;

            if(config.isDemoUser){
                $('body').addClass('dpo-demo-user');
            }
            
            deleteExportButtonsForDemoUser();
            bindExports();
        },
        generateDocument: function (element, url) {
            MDB.downloadDocument({
                defaultFilename: 'export.pdf',
                element: element,
                url: url 
            });
        },
        showLoading: function() {
            $('body').append('<div class="modal-backdrop show"></div>');
            $('body').append('<div class="dpo-loader"></div>');
        },
        hideLoading: function() {
            $('.modal-backdrop').remove();
            $('.dpo-loader').remove();
        },
        initProcessingAgreementExportForm: function(form){
            form = $(form);

            deleteExportButtonsForDemoUser(form);

            MDB.initBootstrapSwitchesDependantControls(form.find('.enable-switch'));
            MDB.Collections.setupFormCollections($('.subprocessors-container'));
        }
    });
    
    function bindExports(){
        //Wire regular buttons to export on click
        selectExportButtons().on('click', function (e) {
            e.preventDefault();
            MDB.DPO.Export.generateDocument(this);
        });

        //Hijack our forms and force a download
        selectExportForms().on('submit', function(e) {
            e.preventDefault();

            //Validation should be either disabled or valid
            var $this = $(this);
            var isValid = !$this.valid || $this.valid();

            if (isValid && !_config.isDemoUser) {
                MDB.DPO.Export.generateDocument($this);
            }
        });

        $('.dpo-pdf-popup-export-form').on('click', function (e) {
            var me = $(this)
                , formUrl = me.data('formUrl')
                , title = me.data('title');

            var loadFormProm = $.ajax({
                url: formUrl
            });

            MDB.modal({
                buttons: ['<button type="button" class="btn btn-default btn-ok dpo-pdf-export-form-submit">Ok</button>'],
                events: {
                    'hidden.bs.modal': function(){
                        $(this).remove(); 
                    }
                },
                shapeHtml: function (html) {
                    deleteExportButtonsForDemoUser(html);

                    html.find('.modal-header').prepend($('<div />', { class: 'text-bold' }).text(title));
                    html.find('.modal-dialog').addClass('modal-xl');

                    var body = html.find('.modal-body');
                    body.html($('<div />', { class: 'loading' }));
                    
                    loadFormProm.done(function (res) {
                        var form = $('<form />', { action: formUrl, method: 'POST' });

                        form.append(res);
                        $.validator.unobtrusive.parse(form);

                        body.html(form);

                        //Only processing agreement is shown in a popup
                        //replace once we start using more forms in this way
                        MDB.DPO.Export.initProcessingAgreementExportForm(form);

                        html.find('.dpo-pdf-export-form-submit').on('click', function () {
                            if (form.valid()) {
                                MDB.killOpenModals();
                                MDB.DPO.Export.generateDocument(form);
                            }
                        });
                    });
                }
            });
        });
    }
    
    function deleteExportButtonsForDemoUser(context){
        if(_config.isDemoUser){
            deleteExportButtons(context);
        }
    }
    
    function deleteExportButtons(context){
        //Removing export buttons should be enough to fool the average user
        selectExportButtons(context)
            .add(selectExportFormSubmitButtons(context))
            .remove();
        
        selectExportForms(context)
            .attr('action', '/')
            .on('submit', function(e){
                e.preventDefault();
                e.stopPropagation();
                
                return false;
            });
    }
    
    function selectExportButtons(context){
        return $(context || document).find('a.dpo-pdf-export');
    }
    
    function selectExportFormSubmitButtons(context){
        return $(context || document).find('.dpo-pdf-export-form-submit');
    }
    
    function selectExportForms(context){
        return $(context || document).find('form.dpo-pdf-export-form');
    }
}());
